import { Form, Formik, FormikHelpers, Field } from "formik";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import * as yup from "yup";
import { expirationTime } from "../../../../helpers/expirationTime";
import { useCookies } from "react-cookie";
// import { postData } from '../../../../services';

import toast from "react-hot-toast";
import {
  confimationStyles,
  errorStyles,
} from "../../../../assets/styles/toast";
import Error from "../../../atoms/Error";
import { postData } from "../../../../services";
import TextInput from "../../../atoms/TextInput";
import Mail from "../../../icons/Mail";

const ForgotPassForm = () => {
  const [cookie,setCookie] = useCookies(['e_t'])
  const [pageError, setPageError] = useState(null);
  const navigate = useNavigate();

  const initialValues = {
    email: "",
    password: null,
  };

  const validationSchema = yup.object().shape({
    email: yup
      .string()
      .email("Invalid email address")
      .required("Email is required"),
  });

  const handleSubmit = async (values, { resetForm }) => {
    try {
      const lowercaseEmail = values.email.toLowerCase();
      const updatedValues = { ...values, email: lowercaseEmail };
      const { data: resultData } = await postData({
        endpoint: "Auth/employeeLogin",
        data: {},
        params: updatedValues,
      });

      if (resultData.status) {
        setCookie("euid", resultData.data.user_id, {
          path: "/",
          expires: expirationTime(),
          // secure: true,
        });
        setCookie("eml", resultData.data.email, {
          path: "/",
          expires: expirationTime(),
          // secure: true,
        });
        setCookie("eut", resultData.data.user_type, {
          path: "/",
          expires: expirationTime(),
          // secure: true,
        });
        toast.success(resultData.message, {
          duration: 1000,
          style: confimationStyles,
        });
        navigate("/auth/verify");
      } else {
        toast.error(resultData.message, { duration: 1000, style: errorStyles });
        setPageError(
          "This email is not registered with us. Please enter your registered email. If your email has changed, please email us."
        );
      }
    } catch (error) {
      console.log(error);
    }
  };
  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={handleSubmit}
    >
      {({
        handleSubmit,
        isSubmitting,

        values,
      }) => (
        <Form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="">Email</label>
            <TextInput
              name="email"
              type="text"
              className="primary-input"
              placeholder="Enter Email"
              customholder="Enter Email"
              autoComplete="off"
              onInput={(e) => {
                e.target.value = e.target.value.replace(/\s/g, "");
              }}
              icon={<Mail />}
              InputHeight="large"
            />
          </div>

          <button
            className="auth_btn btn-primary w-100 mt-4"
            disabled={isSubmitting}
            type="submit"
          >
            Send OTP
            {isSubmitting && (
              <span
                className="spinner-border spinner-border-sm ms-2"
                role="status"
                aria-hidden="true"
              ></span>
            )}
          </button>

          <button
            className="auth_btn btn-outline-primary w-100 mt-4"
            type="button"
            onClick={() => navigate("/auth/login")}
          >
            Continue with Password and OTP
          </button>
        </Form>
      )}
    </Formik>
  );
};

export default ForgotPassForm;
